export default __webpack_public_path__ + "static/media/dng_promotion.f8f81ca9.png";